import { getCurrentBreakpoint } from '@debijenkorf/app-shell';
import { SectionHeader } from '@debijenkorf/text';

import { mapCarouselProductToCarouselItem } from './mappers/mapCarouselProductToCarouselItem';

import { ProductCarousel } from '@/components/Carousels/ProductCarousel';
import { useListTracking } from '@/hooks/tracking';
import { useWishlist } from '@/hooks/wishlist/useWishlist';
import type { CarouselProductMapperProps } from '@/services/mappers/common/carouselProductMapper';
import { PDP_TRACK_LOCATION } from '@/utilities/tracking';
import { mapListProductToGA4Item } from '@/utilities/tracking/adapters/mapListProductToGA4Item';

export type CarouselSectionProps = {
  title: string;
  products?: CarouselProductMapperProps[];
  itemPrefix: string;
  listName: string;
  location?: string;
  onDeleteItem?: (code: string, length?: number) => void;
};

export const CarouselSection = ({
  title,
  products = [],
  itemPrefix,
  listName,
  location = PDP_TRACK_LOCATION,
  onDeleteItem,
}: CarouselSectionProps) => {
  const headerId = `${itemPrefix}-header`;

  const analyticsData = { location, listName, mapProductToGA4Item: mapListProductToGA4Item };

  const { ref, handleAnalyticsEvent } = useListTracking({ products, analyticsData });
  const { combinedProductCodes, onWishlistChange } = useWishlist({ products, analyticsData });

  if (!products.length) return null;

  return (
    <SectionHeader aria-labelledby={headerId} title={title} fullWidthContent>
      <ProductCarousel
        ref={ref}
        withInlineSpace
        itemLabelledbyPrefix={itemPrefix}
        aria-labelledby={headerId}
        items={products.map(mapCarouselProductToCarouselItem)}
        currentBreakpoint={getCurrentBreakpoint()}
        onWishlistChange={onWishlistChange}
        combinedProductCodes={combinedProductCodes}
        onAnalyticsEvent={handleAnalyticsEvent}
        onDeleteItem={onDeleteItem}
      />
    </SectionHeader>
  );
};
